import React, {useRef, useState} from "react";
import {RiCloseCircleFill} from "react-icons/ri";
import {isEmpty} from "lodash";
import {toast} from "react-hot-toast";
import {generateVideoThumbnails} from "@rajesh896/video-thumbnails-generator";
import {FiPlayCircle} from "react-icons/fi";
import Loader from "../../kits/Loader/Loader.tsx";
import ColorSchema from "../color/index.ts";
import {BsPlus} from "react-icons/bs";

type UploadFileProps = {
    name: string
    mode: "multi" | "single",
    typeFile: "multi" | "image" | "video",
    file: any,
    setFile: (value: any) => void
    onChange?: (files) => void
}

type File = {
    id?: string,
    preview?: string,
    file?: any,
    type?: "image" | "video",
}

/*
برای استفاده یک state به نام فایل می میخوایم.
 const [files, setFiles] = useState({cover: {},file: []});

 name حتما باید ارسال شود و باید با نامی که در object فایل نوشتید یکی باشد



 */

const UploadFile = React.forwardRef<any, UploadFileProps>(
    (
        {
            name,
            mode = "single",
            typeFile = "multi",
            file,
            setFile,
            onChange
        },
        ref
    ) => {


        const fileInputRef = useRef(null);

        const [loading, setLoading] = useState(false);

        const handleFileChange = (e) => {
            const selectedFile = e.target.files[0];
            const type = selectedFile.type;

            if (!type.includes("video") && !type.includes("image")) {
                return toast.error("فرمت فایل پشتیبانی نمی شود!");
            } else if (type.includes("video") && selectedFile.size > 2000000) {
                return toast.error("سایز مجاز ویدیو کمتر از 10 مگابایت می باشد!");
            } else if (type.includes("image") && selectedFile.size > 2000000) {
                return toast.error("سایز مجاز عکس کمتر از 4 مگابایت می باشد!");
            }

            if (selectedFile) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    if (mode == "single") {
                        setFile(prev => ({
                            ...prev, [name]: {
                                index: 0,
                                preview: event.target.result,
                                file: selectedFile,
                                type: "image"
                            }
                        }));
                    } else {
                        if (type.includes("video")) {
                            setLoading(true);
                            generateVideoThumbnails(selectedFile, 10).then((thumbnailArray) => {
                                setLoading(false);
                                setFile(prev => ({
                                    ...prev, [name]: [...prev[name], {
                                        index: prev[name].length,
                                        preview: thumbnailArray[3],
                                        file: selectedFile,
                                        type: "video"
                                    }]
                                }));
                            }).catch((err) => {
                                console.error(err);
                            })
                        } else {
                            setFile(prev => ({
                                ...prev, [name]: [...prev[name], {
                                    index: prev[name].length,
                                    preview: event.target.result,
                                    file: selectedFile,
                                    type: "image"

                                }]
                            }));
                        }
                    }
                };
                reader.readAsDataURL(selectedFile);
            } else {
                setFile({});
            }
        };


        if (file && !file[name]) {
            setFile(prev => ({...prev, [name]: []}));
        }

        const delFile = (item) => {
            setFile(prev => ({
                ...prev,
                [name]: (mode == "single") ? {} : file[name].filter(it => it.index != item.index)
            }));
            fileInputRef.current.value = "";
        }


        return file && (

            <div className="d-flex flex-wrap">
                {(mode == "single") ? (
                    <div className="position-relative mr-l-12 mr-b-12">
                        {(!isEmpty(file[name].preview)) && (
                            <>

                                {file[name].type == "image" ? (
                                    <div className="wh-68 position-relative">
                                        <div
                                            className="d-flex justify-content-center align-content-center position-absolute wh-20 bg-rd-01 rd-4 mr-4"
                                            style={{zIndex: 0}}>
                                                <span
                                                    className="font-8-400 text-white m-auto">img</span>
                                        </div>
                                        <img
                                            src={(file[name].preview != null) && file[name].preview}
                                            className="wh-68 rd-8"/>
                                    </div>
                                ) : (
                                    <div className="wh-68 position-relative">
                                        <div
                                            className="d-flex justify-content-center align-content-center position-absolute wh-20 bg-warning text-warning rd-4 mr-4"
                                            style={{zIndex: 0}}>
                                            <FiPlayCircle
                                                className="wh-16 text-dark m-auto"/>
                                        </div>
                                        <img
                                            src={(file[name].preview != null) && file[name].preview}
                                            className="wh-68 rd-8"/>
                                    </div>
                                )}
                                <RiCloseCircleFill
                                    onClick={() => delFile(file[name])}
                                    style={{transform: "translate(95%,25%)"}}
                                    className="ms-1 list-item wh-24 pd-4 rounded-circle color-white pointer fs-3 position-absolute end-0 bottom-0 text-secondary"
                                />
                            </>
                        )}
                    </div>
                ) : ((file[name].length > 0) && file[name].map((item) => (
                        <div className="position-relative mr-l-12 mr-b-12">
                            {(item.preview) && (
                                <>
                                    {item.type == "image" ? (
                                        <div className="wh-68 position-relative">
                                            <div
                                                className="d-flex justify-content-center align-content-center position-absolute wh-20 bg-rd-01 rd-4 mr-4"
                                                style={{zIndex: 0}}>
                                                <span
                                                    className="font-8-400 text-white m-auto">img</span>
                                            </div>
                                            <img
                                                src={(item.preview != null) && item.preview}
                                                className="wh-68 rd-8"/>
                                        </div>
                                    ) : (
                                        <div className="wh-68 position-relative">
                                            <div
                                                className="d-flex justify-content-center align-content-center position-absolute wh-20 bg-warning text-warning rd-4 mr-4"
                                                style={{zIndex: 0}}>
                                                <FiPlayCircle
                                                    className="wh-16 text-dark m-auto"/>
                                            </div>
                                            <img
                                                src={(item.preview != null) && item.preview}
                                                className="wh-68 rd-8"/>
                                        </div>
                                    )}


                                    <RiCloseCircleFill
                                        onClick={() => delFile(item)}
                                        style={{transform: "translate(95%,25%)"}}
                                        className="ms-1 list-item wh-24 pd-4 rounded-circle color-white pointer fs-3 position-absolute end-0 bottom-0 text-secondary"
                                    />
                                </>
                            )}
                        </div>
                    ))
                )}


                {((mode == "single" && isEmpty(file[name])) || mode == "multi") && (
                    <div
                        onClick={() => fileInputRef.current.click()}
                        className={`d-flex justify-content-center ${(mode != "single") && "mr-b-12"} align-items-center pointer wh-68 border-dashed border-secondary border-opacity-50 rd-8 ${(mode == "multi" && file[name].length > 0) && "mr-r-12"}`}>

                        {loading ? (
                            <Loader width={32} colorMain={"#4c6aff"}/>
                        ) : (
                            <BsPlus
                            className="text-secondary text-opacity-50 wh-28"/>
                            )}
                    </div>
                )}

                <input
                    type="file"
                    accept={typeFile == "multi" ? "*" : `${typeFile}/*`}
                    multiple={true}
                    ref={fileInputRef}
                    style={{display: "none"}}
                    onChange={handleFileChange}
                />
            </div>
        );
    }
)
export default UploadFile;